import styled from "styled-components";
import { colors2 } from "oolib";

// Bare heading text at rest; the box (bg + border) appears only while the
// input inside has focus. Transparent border when idle so entering edit mode
// doesn't shift the title. The typo class lives on THIS node — the input and
// the auto-grow mirror both inherit the font from it, so text and mirror can
// never disagree on metrics.
export const StyledEditableTitle = styled.div`
  cursor: ${({ readOnly }) => (readOnly ? "default" : "text")};
  padding: 0.2rem 0.4rem;
  border-radius: 6px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  align-self: center;
  /* lets the title truncate instead of widening the header */
  min-width: 0;

  &:focus-within {
    background-color: ${colors2.grey10};
    border-color: ${colors2.grey40};
  }
`;

// The CSS auto-growing-input trick: the hidden ::after mirror renders the
// current value (via data-value) in the same font and sets the grid track's
// width; the input is stacked on the same cell and just fills it. Capped by
// the container, so long titles ellipsize instead of pushing the layout.
export const StyledAutoGrow = styled.span`
  display: inline-grid;
  min-width: 0;
  max-width: 100%;

  &::after {
    content: attr(data-value) " ";
    visibility: hidden;
    white-space: pre;
    grid-area: 1 / 1;
    overflow: hidden;
  }
`;

export const StyledTitleInput = styled.input`
  grid-area: 1 / 1;
  width: 100%;
  min-width: 2ch;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  font: inherit;
  color: inherit;
  letter-spacing: inherit;
  text-overflow: ellipsis;

  &::placeholder {
    color: ${colors2.grey40};
  }
`;

export const StyledIdleText = styled.div`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
